import { Modal } from 'flowbite-react';
import { FormikProvider, useFormik } from 'formik';

import { useToastContext } from '../../../../common/components/ui/toast/toast.context';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';

import { useEffect, useMemo, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { convertRenterToLead } from '../../../../common/services/renters.api';

type Props = {
  renter: { _id: string, name: string }
  onClose: () => void
}

export default function ModalConvertRenter(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()
  const [isConverted, setIsConverted] = useState(false);
  const [submitResult, setSubmitResult] = useState<string | null>(null);

  const formik = useFormik({
    initialValues: {
      renterId: props.renter._id,
      name: props.renter.name
    },
    onSubmit: async (data) => {
      const activationData = {
        renterId: data.renterId
      }
      const result = await convertRenterToLead(activationData)
      if (!result.ok) {
        notifyError(result.message as string)
        setSubmitResult('error');
        return
      }
      notifySuccess("Conversão realizada com sucesso!")
      setSubmitResult('success');
    }
  })
  const badgeColor = useMemo(() =>
    (submitResult == "success")
      ? 'text-greenPrimary'
      : 'text-redPrimary'
    , [submitResult])

  useEffect(() => {
    setIsConverted(submitResult === 'success')
  }, [submitResult]);

  return (
    <Modal
      className='relative dark:text-black '
      show={true}
      onClose={() => props.onClose()}
    >
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <Modal.Header className='dark:text-black'>
            <h2 className='dark:text-black'>Converter {props.renter.name}</h2>
          </Modal.Header>

          <Modal.Body className='w-full relative items-center justify-center border-gray flex flex-col' style={{ minHeight: 'calc(80vh - 200px)', height: 'calc(50vh - 100px)' }}>
            <div className='pb-[24px]'>
              <h2 className="font-semibold ">Clique aqui para transformar Cliente em Lead:</h2>
            </div>
            <div className="grid-div2">
              <ButtonWithLoader
                isLoading={formik.isSubmitting}
                disabled={isConverted}
                onSave={() => setIsConverted(true)}>
                Converter
              </ButtonWithLoader>

              <FaCheckCircle size={24} className={`${badgeColor}`} />
            </div>
          </Modal.Body>
        </FormikProvider>
      </form>

      <Modal.Footer>
      </Modal.Footer>

    </Modal >
  );
}